import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { DcsgAlertComponent } from './dcsg-alert/dcsg-alert.component';
import { DcsgMatFormFieldSelectComponent } from './dcsg-mat-form-field-select/dcsg-mat-form-field-select.component';
import { DcsgMatFormFieldComponent } from './dcsg-mat-form-field/dcsg-mat-form-field.component';
import { DcsgMatSpinnerButtonComponent } from './dcsg-mat-spinner-button/dcsg-mat-spinner-button.component';
import { FieldDefinition } from '@models/field-definition';
import {FocusDirective} from "@app/shared/directives/dsg-focus";
import { DcsgMatFormTextareaComponent } from './dcsg-mat-form-textarea/dcsg-mat-form-textarea.component';
import {SideNavBarComponent} from "@app/shared/side-nav-bar/side-nav-bar/side-nav-bar.component";
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { BsMaterialModule } from './bs-material.module';
import { RouterModule } from '@angular/router';
import { NgpImagePickerModule} from 'ngp-image-picker';
import { ImageDisplayComponent } from '@app/Pages/main-content/historical-image-page/image-display/image-display.component';



@NgModule({
    imports: [
        CommonModule,
        NgxMaskModule.forRoot(),
        FormsModule,
        NgpImagePickerModule,
        ReactiveFormsModule,
        BsMaterialModule,
        RouterModule
    ],
    exports: [
        DcsgMatFormFieldComponent,
        DcsgMatFormFieldSelectComponent,
        DcsgMatFormTextareaComponent,
        DcsgMatSpinnerButtonComponent,
        SideNavBarComponent,
        DcsgAlertComponent,
        LoadingSpinnerComponent,
        BsMaterialModule,
        ImageDisplayComponent
    ],
    declarations: [
        SideNavBarComponent,
        DcsgMatFormFieldComponent,
        DcsgMatFormFieldSelectComponent,
        DcsgMatSpinnerButtonComponent,
        DcsgAlertComponent,
        FocusDirective,
        DcsgMatFormTextareaComponent,
        LoadingSpinnerComponent,
        ImageDisplayComponent
    ],
    providers: [
        FieldDefinition
    ]
})
export class SharedModule {
}
